import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postVisit } from "../actions/postMyVIsit";

export const useVisitMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postVisit,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["visits"],
      });
    },

    retry: 0,
  });
};
